import DraggableButtonDropdown from "./draggable-button-dropdown.jsx";
import {useContext} from "react";
import {WorkScheduleContext} from "../context/work-schedule-context.jsx";
import {translatedKeys} from "../../../utils/work-schedule-i18n.js";
import clsx from "clsx";

const WorkScheduleTeamsTable = () => {
    const {teams} = useContext(WorkScheduleContext);

    const headerCustomCss = "p-1 border border-[#cbccce]  h-[30px] bg-[#E6E6E6] box-border text-start";
    const cellCustomCss = "p-1 border border-[#cbccce] box-border"

    return (
      <table className="w-full text-[14px] text-[#2E3742]!">
          <thead>
          <tr className="w-full">
              <th className={headerCustomCss + " w-[25%]"}>
                  <span className="font-[600] ms-1">Nome</span>
              </th>
              <th className={headerCustomCss + " w-[25%]" }>
                  <span className="font-[600] ms-1">Jornada de trabalho</span>
              </th>
              <th className={headerCustomCss + " w-[20%]"}>
                  <span className="font-[600] ms-1">Horário inicial</span>
              </th>
              <th className={headerCustomCss + " w-[30%]"}>
                  <span className="font-[600] ms-1">Turnos</span>
              </th>
          </tr>
          </thead>
          <tbody>
          {
            teams.length > 0 &&
            teams.filter(team => !team.processed).map((team, id) => (
              <tr className="odd:bg-[#fafafa] even:bg-[#efefef]" key={team.id}>
                  <td className={cellCustomCss}>{team.name}</td>
                  <td className={cellCustomCss}>{translatedKeys[team.scale] ?? team.scale}</td>
                  <td className={clsx(cellCustomCss, "text-center")}>{team.turnInitialHour.substring(0,5) ?? "-"}</td>
                  <td className={cellCustomCss + ""}><DraggableButtonDropdown team={team}/></td>
              </tr>
            ))
          }
          </tbody>
      </table>
    )
}

export default WorkScheduleTeamsTable;